import { type ComponentPropsWithoutRef, type FC } from 'react';
import { cn } from '../lib/utils';
import { RadioGroupItem as ShadRadioGroupItem } from './ui/radio-group';

type RadioGroupItemProps = ComponentPropsWithoutRef<typeof ShadRadioGroupItem>;

export const RadioGroupItem: FC<RadioGroupItemProps> = (props) => {
  return (
    <ShadRadioGroupItem
      {...props}
      className={cn(
        'size-5 border-border-strong bg-transparent data-[state=checked]:border-primary dark:bg-transparent [&_svg]:size-3',
        props.className,
      )}
    />
  );
};

export { RadioGroup } from './ui/radio-group';
